module.exports = __webpack_public_path__ + "img/expressjs.e812bec1.png";